module.exports = __webpack_public_path__ + "static/media/calenderIcon.2d7237c8.svg";